import '../styles/main.css';

import App from './pages/app';

async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.bundle.js', {
        scope: '/'
      });
      
    } catch (error) {
      
    }
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  await registerServiceWorker();
  
  const app = new App();

  const guestLoginBtn = document.getElementById('guest-login-btn');
  if (guestLoginBtn) {
    guestLoginBtn.addEventListener('click', () => {
      app.navigateTo('auth');
    });
  }
  
  window.addEventListener('error', (e) => {
    if (app && app.showToast) {
      app.showToast('Terjadi kesalahan sistem', 'error');
    }
  });
  
  window.addEventListener('unhandledrejection', (e) => {
    if (app && app.showToast) {
      app.showToast('Terjadi kesalahan jaringan', 'error');
    }
  });
});